<script setup>
  import { onUnmounted } from "vue";
  import { storeToRefs } from "pinia";

  import MCampaignsTable from "@/components/MCampaign/MCampaignsTable.vue";
  import MCampaignNew from "@/components/MCampaign/MCampaignNew.vue";
  import SyncMultiCountryModal from "@/components/MCampaign/SyncMultiCountryModal.vue";
  import { IndexPageLayout, IndexPageFilters } from "@/components/App/IndexPage";
  import { FilterDropdown } from "@/components/episto-ui/filter-dropdown";
  import { useMCampaignsFilters } from "@/utils/composables/filters/useMCampaignsFilters";
  import { useMCampaignsStore } from "@stores/mCampaigns";
  import { useMCampaignStore } from "@stores/mCampaign";

  const mCampaignStore = useMCampaignStore();
  const { isNewCampaignVisible } = storeToRefs(mCampaignStore);

  const mCampaignsStore = useMCampaignsStore();
  const { mCampaignsSearchQuery } = storeToRefs(mCampaignsStore);
  const { resetAllFilters } = mCampaignsStore;

  const { filterConfigs, activeFiltersCount, handleFilterChange, handleClear } = useMCampaignsFilters();

  onUnmounted(() => resetAllFilters());
</script>

<template>
  <IndexPageLayout
    title="Campaigns"
    action-label="New campaign"
    @action="isNewCampaignVisible = true">
    <template #filters>
      <IndexPageFilters
        v-model:search-model-value="mCampaignsSearchQuery"
        search-placeholder="Search campaigns">
        <template #filters>
          <FilterDropdown
            :filters="filterConfigs"
            :active-filters-count="activeFiltersCount"
            @toggle="handleFilterChange"
            @clear="handleClear" />
        </template>
      </IndexPageFilters>
    </template>

    <MCampaignsTable />

    <template #dialogs>
      <MCampaignNew />
      <SyncMultiCountryModal />
    </template>
  </IndexPageLayout>
</template>
